import { render } from "./PalworldEulaView.vue?vue&type=template&id=4de1cd7c"
import script from "./PalworldEulaView.vue?vue&type=script&lang=js"
export * from "./PalworldEulaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__